import React from "react";
import { SettingOutlined } from "@ant-design/icons";

import DashboardLayout from "../../layout/dashboardLayout/DashboardLayout";
import CrmSettings from "./CrmSettings";
import "./crm.css";

// Standalone page for the CRM Settings (readiness reminders + email templates),
// extracted from the old CrmPage "Settings" tab. CrmSettings is self-contained;
// this just wraps it in the dashboard chrome + the shared crm-page header. The
// menu item is super-admin-gated, and every endpoint it hits is IsSuperUser, so
// no extra client-side guard is needed here.
export default function CrmSettingsPage() {
  return (
    <DashboardLayout>
      <div className="crm-page">
        <div className="crm-page-head">
          <div className="crm-page-head-left">
            <span className="crm-page-icon"><SettingOutlined /></span>
            <div>
              <div className="crm-page-title">CRM Settings</div>
              <div className="crm-page-sub">Onboarding, plans &amp; trials, sales tax, reminders &amp; email templates</div>
            </div>
          </div>
        </div>
        <CrmSettings />
      </div>
    </DashboardLayout>
  );
}
